import { useState } from "react";

import {
  InputChoice,
  InputChoiceLabel,
  InputChoices,
} from "@/blocks/InputChoices";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

export function PlaygroundInputChoices() {
  const [binary, setBinary] = useState<string | null>("yes");
  const [multiple, setMultiple] = useState<string | null>("b");

  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Binary (first = green, last = red)
        </PlaygroundSubSectionTitle>
        <div className="flex w-[320px] flex-col gap-4">
          <InputChoices mode="binary" value={binary} onChange={setBinary}>
            <InputChoice value="yes">
              <InputChoiceLabel>Yes</InputChoiceLabel>
            </InputChoice>
            <InputChoice value="no">
              <InputChoiceLabel>No</InputChoiceLabel>
            </InputChoice>
          </InputChoices>
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Multiple (neutral)
        </PlaygroundSubSectionTitle>
        <div className="flex w-[320px] flex-col gap-4">
          <InputChoices mode="multiple" value={multiple} onChange={setMultiple}>
            <InputChoice value="a">
              <InputChoiceLabel>A</InputChoiceLabel>
            </InputChoice>
            <InputChoice value="b">
              <InputChoiceLabel>B</InputChoiceLabel>
            </InputChoice>
            <InputChoice value="c">
              <InputChoiceLabel>C</InputChoiceLabel>
            </InputChoice>
          </InputChoices>
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Disabled (muted, even when selected)
        </PlaygroundSubSectionTitle>
        <div className="flex w-[320px] flex-col gap-4">
          <InputChoices mode="binary" value="yes">
            <InputChoice value="yes" disabled>
              <InputChoiceLabel>Yes</InputChoiceLabel>
            </InputChoice>
            <InputChoice value="no" disabled>
              <InputChoiceLabel>No</InputChoiceLabel>
            </InputChoice>
          </InputChoices>
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
